<template>
    <div class="tela-vantagem-detalhe" v-if="partner">
        <div class="box-shadow">
            <router-link class="margindefault back" :to="{ name: 'vantagens', query: {c: partner.partnerCategory.title }}" :title="'Voltar'">{{ t('IR_PARA_CATEGORIA') }}</router-link>
            <div class="destaque-banners" v-if="partner.spotlight">
                <BannerSliced v-if="!isMobile() && partner.bannerSpotlightDesktop" :mobile="false" :images="partner.bannerSpotlightDesktop" />
                <BannerSliced v-if="isMobile() && partner.bannerSpotlightMobile" :mobile="true" :images="partner.bannerSpotlightMobile" />
            </div>
            <div class="destaque-icones" v-if="partner.spotlight">
                <div v-if="partner.icon1">
                    <img :src="partner.icon1.imageUrl" alt="">
                    <div><div v-html="partner.textIcon1"></div></div>
                </div>
                <div v-if="partner.icon2">
                    <img :src="partner.icon2.imageUrl" alt="">
                    <div><div v-html="partner.textIcon2"></div></div>
                </div>
                <div v-if="partner.icon3">
                    <img :src="partner.icon3.imageUrl" alt="">
                    <div><div v-html="partner.textIcon3"></div></div>
                </div>
            </div>
            <div class="banner" v-if="partner.bannerPadraoDesktop">
                <img v-if="!isMobile()" :src="partner.bannerPadraoDesktop.imageUrl" :alt="partner.title">
                <img v-if="isMobile()" :src="partner.bannerPadraoMobile.imageUrl" :alt="partner.title">
            </div>
            <div class="texto" v-html="partner.textSite"></div>
            <div class="botoes">
                <a v-for="(button, i) of partner.partnerButtonsSite" :key="i" :href="button.url">{{button.text}}</a>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.box-shadow {
    box-shadow: 0 0 2px rgba(0,0,0,0.2);
    width: auto;
    max-width: 1170px;
    margin: 0 auto;
    height: auto;
    overflow: auto;
}
    .tela-vantagem-detalhe {
        margin: 2% auto;  
    }
    .tela-vantagem-detalhe p { 
        text-align: left;
    }
    .destaque-icones {
        width: 90%;
        margin: 0 auto;
        display: flex;
        > div {
            width: calc(100% / 3);
            padding: 40px;
            display:flex;
            flex-direction: column;
            align-items: center;
            line-height: 24px;
            text-align: center;
            img {
                max-width: 40%;
                margin-bottom: 20px;
            }
        }
    }
    .texto {
        padding: 40px;
        line-height: 24px;
        p {
            margin: 1em 0;
        }
    }
    .banner img { width: 100% }
    .botoes {
        text-align: center;
        a {
            padding: 15px 40px;
            background:#E46C0A;
            color: white;
            display: inline-block;
            border-radius: 10px;
            margin: 10px;
            //text-transform: lowercase;
            font-size: 16px;
        }
    }
    @media(max-width: 992px) {
        .tela-vantagem-detalhe { margin: 0;}
        .destaque-icones {
            width: 100%;
            margin: 0;
            flex-direction: column;
            > div {
                width: 100%;
                padding: 15px;
                flex-direction: row;
                align-items: center;
                text-align: left;
                > div {
                    flex: 1;
                    padding-left: 15px;
                }
                img {
                    width: 30%;
                    margin: 0;
                    max-width: auto;
                }
            }
        }
        .texto {
            padding: 15px;
        }
        .botoes {
            a {
                width: calc(100% - 20px);
                display: block;
              
            }
        }
    }
</style>

<script>
    import { isMobile, resolvePromise, redirect } from '../helpers/helpers'
    import { getPartnerBySlug } from '../services/partner.service.js'
    import { baseURL } from '../config/http';
    import BannerSliced from '@/components/BannerSliced.vue'
import { translate } from '../services/translate.service';
    export default {
    name: 'vantagensDetalhe',
    data(){
        return{
            partnerSlug: null,
            partner: null,
        }
    },
    components: {
        BannerSliced
    },
    methods:{
        t:translate,
        isMobile
    },
    created(){
        const {userData} = this.$attrs;
        this.partnerSlug = this.$route.params.slug;
        console.log('partnerSlug', this.partnerSlug);
        resolvePromise(getPartnerBySlug(this.partnerSlug),({data})=>{
            if(!data) redirect("vantagens", this);
            this.partner = data;
            this.partner.jsonBotoesDestaque = JSON.parse(this.partner.jsonBotoesDestaque || '{}');
            if(this.partner.icon1) this.partner.icon1.imageUrl = baseURL + this.partner.icon1.imageUrl.replace(/\\/gm,'/')
            if(this.partner.icon2) this.partner.icon2.imageUrl = baseURL + this.partner.icon2.imageUrl.replace(/\\/gm,'/')
            if(this.partner.icon3) this.partner.icon3.imageUrl = baseURL + this.partner.icon3.imageUrl.replace(/\\/gm,'/')
            if(this.partner.bannerPadraoDesktop) this.partner.bannerPadraoDesktop.imageUrl = baseURL + this.partner.bannerPadraoDesktop.imageUrl.replace(/\\/gm,'/')
            if(this.partner.bannerPadraoMobile) this.partner.bannerPadraoMobile.imageUrl = baseURL + this.partner.bannerPadraoMobile.imageUrl.replace(/\\/gm,'/')
            if(this.partner.bannerSpotlightDesktop) {
                this.partner.bannerSpotlightDesktop = this.partner.bannerSpotlightDesktop
                .sort((a, b) => {
                    return parseInt(a.type.substr(-1)) - parseInt(b.type.substr(-1))
                }).map(v => {
                    v.imageUrl = baseURL + v.imageUrl.replace(/\\/gm,'/');
                    v.link = this.partner.jsonBotoesDestaque['d_' + parseInt(v.type.substr(-1))] || '';
                    return v;
                })
            }
            if(this.partner.bannerSpotlightMobile) {
                this.partner.bannerSpotlightMobile = this.partner.bannerSpotlightMobile
                .sort((a, b) => {
                    return parseInt(a.type.substr(-1)) - parseInt(b.type.substr(-1))
                }).map(v => {
                    v.imageUrl = baseURL + v.imageUrl.replace(/\\/gm,'/')
                    v.link = this.partner.jsonBotoesDestaque['m_' + parseInt(v.type.substr(-1))] || '';
                    return v;
                })
            }

            if(this.partner.partnerButtonsSite){
                var userLogged = !!userData;
                this.partner.partnerButtonsSite = this.partner.partnerButtonsSite
                    .filter((v) => v.active)
                    .filter((v) => v.loggedUser == 'Todos' || (v.loggedUser == 'Não' && !userLogged) ||  (v.loggedUser == 'Sim' && userLogged));
            }
        },console.error,this);
    }
    }
</script>
